import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HazardsContainerComponent } from './hazards-container/hazards-container.component';
import { HazardsEditComponent } from './hazards-edit/hazards-edit.component';
import { HazardsViewComponent } from './hazards-view/hazards-view.component';
import { HazardsComponent } from './hazards/hazards.component';
import { HazardsVerifyComponent } from './hazards-verify/hazards-verify.component';
import { AuthGuard } from '../guards/auth.guard';
import { RBACGuard } from '../guards/rbac.guard';
import { RBACService } from '../shared/rbac.service';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import {SitesImporterComponent} from "../sites/sites-importer/sites-importer.component";
import {HazardsImporterComponent} from "./hazards-importer/hazards-importer.component";

const routes: Routes = [
  {
    path: 'hazards',
    component: HazardsComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.HAZARDS }
  },
  {
    path: 'hazards/importer',
    component: HazardsImporterComponent,
    canActivate: [
      AuthGuard,
      PlanGuard,
      RBACGuard
    ],
    data: {
      planFeature: AppService.FEATURES.HAZARDS,
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_REGISTERS_HAZARDS_RISKS, RBACService.RBAC_A.A_CREATE)
      ],
      exact: true
    }
  },
  {
    path: 'hazards/:hazard_id',
    component: HazardsContainerComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.HAZARDS },
    children: [
      { path: 'edit', component: HazardsEditComponent },
      { path: 'view', component: HazardsViewComponent }
    ]
  },
  { path: 'hazards/:hash/verify', component: HazardsVerifyComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HazardsRoutingModule {}
